export default class MediaLibraryCollectionStorage
{
    constructor()
    {
        /** @type {number[]} */
        this._assets = [];
        /** @type {string} */
        this._collectionPrefix = 'ml-assets-';
        /** @type {string} */
        this._timestampPrefix = 'ml-timestamp-';
    }

    /**
	 * Add an asset to the collection
	 * @param {number} assetId - The asset id to add
	 */
    addToCollection(assetId)
    {
        if (!assetId || this._assets.includes(assetId))
        {
            console.warn('Asset id not set or already in collection');
            return;
        }

        this._assets.push(assetId);
    }

    /**
	 * Remove an asset from the collection
	 * @param {number} assetIdToRemove - The asset id to remove
	 */
    removeFromCollection(assetIdToRemove)
    {
        if (!assetIdToRemove)
        {
            console.warn('Asset id not set');
            return;
        }

        this._assets = this._assets.filter(assetId => assetId !== assetIdToRemove);
    }

    /**
	 * Get the collection
	 * @return {number[]} The collection
	 */
    getCollection()
    {
        return this._assets;
    }

    /**
	 * Save the collection to local storage
	 * @param {string} customerId - The customer ID
	 */

    saveCollection(customerId)
    {
        if (!customerId)
        {
            console.error('customerId is required');
            return;
        }

        localStorage.setItem(this._collectionPrefix + customerId, JSON.stringify(this._assets));
    }

    /**
	 * Restore the collection from local storage
	 * @param {string} customerId - The customer ID
	 */
    restoreCollection(customerId)
    {
        if (!customerId)
        {
            console.error('customerId is required');
            return;
        }

        this._assets = JSON.parse(localStorage.getItem(this._collectionPrefix + customerId));
    }

    /**
	 * Check if the collection exists in local storage
	 * @param {string} customerId - The customer ID
	 * @return {boolean} Whether the collection exists in local storage
	 */
    hasCollection(customerId)
    {
        if (!customerId)
        {
            console.error('customerId is required');
            return false;
        }

        return !!localStorage.getItem(this._collectionPrefix + customerId);
    }

    /**
	 * Clear the collection from local storage
	 * @param {string} customerId - The customer ID
	 */
    clearCollection(customerId)
    {
        if (!customerId)
        {
            console.error('customerId is required');
            return;
        }

        localStorage.removeItem(this._collectionPrefix + customerId);
    }

    /**
	 * Check if the timestamp exists in local storage
	 * @param {string} customerId - The customer ID
	 * @return {boolean} Whether the timestamp exists in local storage
	 */
    hasTimestamp(customerId)
    {
        if (!customerId)
        {
            console.error('customerId is required');
            return false;
        }

        return !!localStorage.getItem(this._timestampPrefix + customerId);
    }

    /**
	 * Get the timestamp from local storage
	 * @param {string} customerId - The customer ID
	 * @return {number} The timestamp
	 */
    getTimestamp(customerId)
    {
        if (!customerId)
        {
            console.error('customerId is required');
            return;
        }

        return JSON.parse(localStorage.getItem(this._timestampPrefix + customerId));
    }

    /**
	 * Set the timestamp in local storage
	 * @param {string} customerId - The customer ID
	 */
    setTimestamp(customerId)
    {
        if (!customerId)
        {
            console.error('customerId is required');
            return;
        }

        localStorage.setItem(this._timestampPrefix + customerId, Date.now().toString());
    }

    /**
	 * Remove the timestamp from local storage
	 * @param {string} customerId - The customer ID
	 */
    removeTimestamp(customerId)
    {
        if (!customerId)
        {
            console.error('customerId is required');
            return;
        }

        localStorage.removeItem(this._timestampPrefix + customerId);
    }
}
